import { TrafficLightConfigType, baseTrafficLightConfig } from '@pp/core/src/components/game/trafficLight/types';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

const TrafficLightExtension: Record<string, TrafficLightConfigType> = {
  TEST: {
    label: 'Test',
    rendersTimer: false,
  },
  PLACEYOURBETS: {
    label: 'NXT_GAME_CAPS',
    rendersTimer: true,
    style: 'default',
    scheduledStatusChange: {
      timeout: (timings) => -timings.bettingLastCall,
      nextStatus: GameStatus.LastBets,
    },
  },
  WAITFORNEXTGAME: {
    label: 'WAITFORNEXTGAME_CAPS',
    rendersTimer: false,
    style: 'none',
  },
  LASTBETS: {
    label: 'NXT_GAME_CAPS',
    rendersTimer: true,
    style: 'warning',
  },
  BETSCLOSED: {
    label: 'BETS_CLOSED',
    rendersTimer: false,
    style: 'none',
  },
  DEALING: {
    label: 'DEALING',
    rendersTimer: false,
    style: 'hide',
  },
  YOUWIN: {
    label: 'YOU_WIN',
    rendersTimer: false,
    style: 'hide',
  },
  RESULT: {
    label: 'RESULT',
    rendersTimer: false,
    style: 'hide',
  },
  GAMECANCELLED: {
    label: 'GAMECANCELLED_CAPS',
    rendersTimer: false,
    style: 'danger',
  },
};

export const highflyerTrafficLightConfig: Record<string, TrafficLightConfigType> = {
  ...baseTrafficLightConfig,
  ...TrafficLightExtension,
};
